import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-di',
  templateUrl: './why-di.component.html',
  styleUrls: ['./why-di.component.scss']
})
export class WhyDiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
